import ActionTypes from "../../../../constants/ActionTypes";
import { ICampaignDetailsState } from "./types";

const initialState: ICampaignDetailsState = {
  offerId: 0,
  optionId: 0,
  tp: null,
  optionName: '',
  terms: '',
  isUpSell: false,
  channelName: '',
  submitEanexMessage: ''
};

const campaignDetailsReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.CAMPAIGN.DETAILS.SET_SOFT_OFFER_PACKAGE:
    return {
      ...state,
      tp: action.payload
    };
  case ActionTypes.CAMPAIGN.DETAILS.SET_OPTION_NAME:
    return {
      ...state,
      optionName: action.payload
    };
  case ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_TERMS:
    return {
      ...state,
      terms: action.payload
    };
  case ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_IS_UP_SELL:
    return {
      ...state,
      isUpSell: action.payload
    };
  case ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_OFFER_ID:
    return {
      ...state,
      offerId: action.payload
    };
  case ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_OPTION_ID:
    return {
      ...state,
      optionId: action.payload
    };
  case ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_CHANNEL_NAME:
    return {
      ...state,
      channelName: action.payload
    };
  case ActionTypes.CAMPAIGN.DETAILS.SET_SUBMIT_EANEX_MESSAGE:
    return {
      ...state,
      submitEanexMessage: action.payload
    };
  }
  return state;
};

export default campaignDetailsReducer;

